export default __webpack_public_path__ + "static/overview3-862ba934b8ed40501d48c801ff0d633b.jpg";